import "./Contactus.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useState, useEffect } from "react";
import clockImg from "../Assets/Home-Header-Footer/clock.png";
import mailImg from "../Assets/Home-Header-Footer/mail.png";
// import locationImg from "../Assets/Home-Header-Footer/clock.png";
import callImg from "../Assets/Home-Header-Footer/mobile.png";
import locationImg from "../Assets/Home-Header-Footer/location.png";
export function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [btnStatus, setBtnStatus] = useState("Submit");

  const onSubmit = async (event) => {
    event.preventDefault();
    setBtnStatus("Submitting...");

    const formData = new FormData(event.target);

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbx4W0tCeHWMS8LOYqXBRQ5U0hgy0jGiQUtx3-_2iRCuhrwhKSxAkqzTkq2Cbr5mum5q/exec";

    const firstname = formData.get("first_name") || "";
    const lastname = formData.get("last_name") || "";
    const phone = formData.get("mobile") || "";
    const email = formData.get("mail") || "";
    const message = formData.get("message") || "";

    const details = `
      Name: ${firstname} ${lastname}
      Phone: ${phone}
      Email: ${email}
      Message: ${message}
    `;

    const web3FormsPayload = {
      access_key: "8b93eb15-6a9c-4edf-b506-6d908d0b2ffc",
      subject: "Hussme Contact Form Submission",
      from_name: `${firstname} ${lastname}`,
      email: email,
      message: details,
    };

    try {
      const [googleSheetsResponse, web3FormsResponse] =
        await Promise.allSettled([
          fetch(scriptURL, { method: "POST", body: formData, mode: "no-cors" }),
          fetch("https://api.web3forms.com/submit", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(web3FormsPayload),
          }).then((res) => res.json()),
        ]);

      let googleSheetsSuccess = googleSheetsResponse.status === "fulfilled";
      let web3FormsSuccess =
        web3FormsResponse.status === "fulfilled" &&
        web3FormsResponse.value?.success;

      if (googleSheetsSuccess || web3FormsSuccess) {
        toast.success("Your message was sent successfully!");
      } else {
        toast.error(
          "We're experiencing technical difficulties. Please try again or contact us directly at support@hussme.com"
        );
      }

      setBtnStatus("Submitted");
      event.target.reset();
      setTimeout(() => setBtnStatus("Submit"), 2000);
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(
        "We're experiencing technical difficulties. Please try again or contact us directly at support@hussme.com"
      );
      setBtnStatus("Submit");
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="contactus-page">
        <div className="contactus-location-and-form-container">
          {/* Contact Location Details Section */}
          <div className="contact-location-section">
            <div className="contact-location-container">
              <h2 className="location-title-contact-us">Contact Us</h2>
              <h2 className="location-title">Hussme</h2>

              <div className="location-details">
                <div className="location-item">
                  <img src={locationImg} className="clock-img" alt="" />
                  <div className="location-info">
                    <span className="location-text ">Fort Mill, SC 29708</span>
                  </div>
                </div>

                <div className="location-item">
                  <img src={callImg} className="clock-img" alt="" />
                  <div className="location-info">
                    <a
                      href="tel:+18032002817"
                      className="location-text location-link"
                    >
                      +1 (803) 200-2817
                    </a>
                  </div>
                </div>

                <div className="location-item">
                  <img src={mailImg} className="clock-img" alt="" />
                  <div className="location-info">
                    <a
                      href="mailto:support@hussme.com"
                      className="location-text location-link"
                    >
                      support@hussme.com
                    </a>
                  </div>
                </div>

                <div className="location-item office-hours-item">
                  <div className="location-info">
                    <div className="office-hours">
                      <div className="hours-title">
                        <img src={clockImg} className="clock-img" alt="" />
                        Office Hours:
                      </div>
                      <div className="hours-schedule">
                        <div className="hours-row">
                          <span className="day">Monday:</span>
                          <span className="time">9:00 AM - 6:00 PM</span>
                        </div>
                        <div className="hours-row">
                          <span className="day">Tuesday:</span>
                          <span className="time">9:00 AM - 6:00 PM</span>
                        </div>
                        <div className="hours-row">
                          <span className="day">Wednesday:</span>
                          <span className="time">9:00 AM - 6:00 PM</span>
                        </div>
                        <div className="hours-row">
                          <span className="day">Thursday:</span>
                          <span className="time">9:00 AM - 6:00 PM</span>
                        </div>
                        <div className="hours-row">
                          <span className="day">Friday:</span>
                          <span className="time">9:00 AM - 6:00 PM</span>
                        </div>
                        <div className="hours-row">
                          <span className="day">Saturday:</span>
                          <span className="time">9:00 AM - 4:00 PM</span>
                        </div>
                        <div className="hours-row dark-row">
                          <span className="day">Sunday:</span>
                          <span className="time">Closed</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="contact-detail-container">
            <form className="contact-input-box hmc-contact-form" onSubmit={onSubmit}>
              <div className="contact-info-title">Have a Question?</div>

              <div className="hmc-form-row">
                <div className="hmc-form-group">
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    placeholder=" "
                    aria-label="First Name"
                    required
                  />
                  <label htmlFor="first_name">
                    First Name <span>*</span>
                  </label>
                </div>
                <div className="hmc-form-group">
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    placeholder=" "
                    aria-label="Last Name"
                    required
                  />
                  <label htmlFor="last_name">
                    Last Name <span>*</span>
                  </label>
                </div>
              </div>

              <div className="hmc-form-row">
                <div className="hmc-form-group">
                  <input
                    type="email"
                    id="mail"
                    name="mail"
                    placeholder=" "
                    aria-label="Email"
                    required
                  />
                  <label htmlFor="mail">
                    Email <span>*</span>
                  </label>
                </div>
                <div className="hmc-form-group">
                  <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    placeholder=" "
                    aria-label="Phone"
                  />
                  <label htmlFor="mobile">Phone</label>
                </div>
              </div>

              <div className="hmc-form-row">
                <div className="comment-box-textarea" style={{ flex: 1 }}>
                  <textarea
                    id="message"
                    name="message"
                    placeholder=" "
                    aria-label="Message"
                  />
                  <label htmlFor="message">Comment</label>
                </div>
              </div>

              <button
                type="submit"
                className="hmc-form-submit"
                disabled={btnStatus !== "Submit"}
              >
                {btnStatus}
              </button>
            </form>
          </div>
        </div>
        {/* New Map Section */}
        <div className="contact-map-container">
          <iframe
            title="Hussme Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.348903838102!2d-80.93522968478549!3d35.007368180353105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885686dd8b6eeb7f%3A0x93e06d6c6e7c3d!2sFort%20Mill%2C%20SC!5e0!3m2!1sen!2sus!4v1694429212345"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </>
  );
}
